import React from "react";

interface Props {
  color: string;
}

const Emoji: React.FC<Props> = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6023 18.3334 9.99996C18.3334 5.39759 14.6025 1.66663 10.0001 1.66663C5.39771 1.66663 1.66675 5.39759 1.66675 9.99996C1.66675 14.6023 5.39771 18.3333 10.0001 18.3333Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 12.5C7.05486 13.0175 7.55813 13.4375 8.13669 13.7268C8.71526 14.0161 9.35323 14.1667 10.0001 14.1667C10.6469 14.1667 11.2849 14.0161 11.8635 13.7268C12.442 13.4375 12.9453 13.0175 13.3334 12.5M6.67425 7.5H6.66675M13.3334 7.5H13.3259"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Emoji;
